var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import NumberRange from "~/components/common/number-range.vue";
import { CaseVerifyService } from "~/services/domain-service/case-verify.service";
import { FileUploadService } from "~/services/file-service/file-upload.service.ts";
import CaseVerified from "~/components/case-verify-manage/case-verified.vue";
import VerifyFileUpload from "~/components/case-verify-manage/verify-file-upload.vue";
import { ApplyType, CASE_CHANNEL } from "~/config/enum.config";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
import TurnSourceApply from "~/components/apply-component/turn-source-apply.vue";
var CaseVerify = /** @class */ (function (_super) {
    __extends(CaseVerify, _super);
    function CaseVerify() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // 数据
        _this.dataSet = [];
        _this.applyType = ApplyType.turn;
        _this.fromChannel = CASE_CHANNEL.verify;
        _this.selectionList = [];
        _this.rowData = null;
        _this.searchModel = {
            caseNumber: "",
            personalName: "",
            mobileNo: "",
            idCard: "",
            customerCategory: "",
            productCategory: "",
            productName: "",
            overdueAmount: {
                max: "",
                min: ""
            },
            caseMoney: { min: "", max: "" },
            overduePeriod: "",
            overdueDays: {
                max: "",
                min: ""
            },
            followInTime: ["", ""],
            area: "",
            turnSource: "",
            commonFlag: "",
            verifyStatus: "",
            labelName: []
        };
        // 弹框控制
        _this.dialog = {
            isOpenCaseVerified: false,
            isOpenApply: false,
            isOpenVerifyFileUpload: false
        };
        return _this;
    }
    CaseVerify.prototype.mounted = function () {
        this.refreshData();
    };
    CaseVerify.prototype.refreshData = function () {
        var _this = this;
        this.caseVerifyService
            .getAllVerifyInfos(this.searchModel, this.pageService)
            .subscribe(function (data) {
            _this.dataSet = data;
            _this.selectionList = [];
        });
    };
    /**
     * 核销
     */
    CaseVerify.prototype.verifiedCaseClick = function () {
        if (this.selectionList.length === 0) {
            this.$message.info("请先选择要核销的案件");
            return;
        }
        if (this.selectionList.find(function (v) { return v.verifyStatus === "VERIFIED"; })) {
            this.$alert("选择的案件存在已核销的案件，请重新选择", "提示", {
                confirmButtonText: "确定"
            });
            return;
        }
        this.dialog.isOpenCaseVerified = true;
    };
    /**
     * 申请流转
     */
    CaseVerify.prototype.applyFlowClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.selectionList.length === 0) {
                    this.$message("\u8BF7\u9009\u62E9\u8981" + this.applyType.name + "\u7684\u6848\u4EF6");
                    return [2 /*return*/];
                }
                this.applyType = ApplyType.turn;
                this.dialog.isOpenApply = true;
                return [2 /*return*/];
            });
        });
    };
    /**
     * 下载附件
     */
    CaseVerify.prototype.viewClick = function (rowData) {
        var _this = this;
        this.fileUploadService
            .getAllUploadFileByIds(rowData.fileIds)
            .subscribe(function (data) {
            var fileList = data.map(function (v) {
                return {
                    url: v.url,
                    filename: v.fileName
                };
            });
            _this.$common.downloadAll(fileList);
        });
    };
    Object.defineProperty(CaseVerify.prototype, "selectedCaseIds", {
        get: function () {
            return this.selectionList.map(function (v) { return v.id; });
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 需要手动重置的表单项
     */
    CaseVerify.prototype.handleResetForm = function () {
        this.searchModel.overdueAmount = { max: "", min: "" };
        this.searchModel.overdueDays = { max: "", min: "" };
        this.searchModel.followInTime = { max: "", min: "" };
        this.searchModel.caseMoney = { min: "", max: "" };
    };
    /**
     * 下载案件
     */
    CaseVerify.prototype.downloadVerifiedCase = function () {
        var _this = this;
        var ids = this.selectionList.map(function (v) { return v.id; });
        var request = __assign(__assign({}, this.searchModel), { caseIds: ids });
        this.caseVerifyService.exportVerifyInfos(request).subscribe(function (data) {
            _this.$common.downloadFile(data.url, "核销案件.xls");
        });
    };
    __decorate([
        Dependencies(PageService)
    ], CaseVerify.prototype, "pageService", void 0);
    __decorate([
        Dependencies(CaseVerifyService)
    ], CaseVerify.prototype, "caseVerifyService", void 0);
    __decorate([
        Dependencies(FileUploadService)
    ], CaseVerify.prototype, "fileUploadService", void 0);
    CaseVerify = __decorate([
        Auth(1901),
        Layout("workspace"),
        Component({
            components: {
                GetLabelName: GetLabelName,
                NumberRange: NumberRange,
                CaseVerified: CaseVerified,
                VerifyFileUpload: VerifyFileUpload,
                TurnSourceApply: TurnSourceApply
            }
        })
    ], CaseVerify);
    return CaseVerify;
}(Vue));
export default CaseVerify;
